import React from "react";
import "./RibbonWrapper.scss";

/**
 * @param {object} props
 * @param {string} props.children
 * @param {object} [props.contentClasses]
 * @param {object} [props.containerClasses]
 * @returns {React.ReactElement}
 */
const RibbonWrapper = ({
    children,
    contentClasses = "",
    containerClasses = "",
}) => (
    <div className={`ribbon-wrapper ${containerClasses}`}>
        <div className={`ribbon-wrapper__h3 ${contentClasses}`}>{children}</div>
    </div>
);

export default RibbonWrapper;
